import { render } from "./4Ggateway.vue?vue&type=template&id=6565fc20"
import script from "./4Ggateway.vue?vue&type=script&lang=js"
export * from "./4Ggateway.vue?vue&type=script&lang=js"

import exportComponent from "/root/.jenkins/workspace/WJ-WEB/htweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__